<template>
  <div>
    <wc-data-box
      title='Field Instructions'
      titleIcon='mdi-format-list-checkbox'
      showHelp
      :helpText='helpText'
    >
      <v-card-text>
        <span class='font-weight-bold mr-2'>General Site Instructions:</span>
        <span>{{ wo.project_obj.field_instructions }}</span>
      </v-card-text>
      <v-card-text v-if='wo.wo_type_obj.category === "SU"' class='pt-0'>
        <span class='font-weight-bold mr-2'>SU Specific Instructions:</span>
        <span>{{ wo.project_obj.project_detail.su_instr_perm_field }}</span>
      </v-card-text>
      <v-card-text v-if='wo.wo_type_obj.category === "SC"' class='pt-0'>
        <span class='font-weight-bold mr-2'>Spring Cleanup Specific Instructions:</span>
        <span>{{ wo.project_obj.project_detail.spring_cleanup_field_instructions }}</span>
      </v-card-text>
      <v-card-text v-if='wo.wo_type_obj.category === "FW"' class='pt-0'>
        <span class='font-weight-bold mr-2'>Fertilizer and Weed Specific Instructions:</span>
        <span>{{ wo.project_obj.project_detail.fertilizer_field_instructions }}</span>
      </v-card-text>
      <v-card-text v-if='wo.wo_type_obj.category === "LC"' class='pt-0'>
        <span class='font-weight-bold mr-2'>Lawn Care Specific Instructions:</span>
        <span>{{ wo.project_obj.project_detail.lawn_care_field_instructions }}</span>
      </v-card-text>
      <v-card-text v-if='suNotes.length' class='pt-0'>
        <span class='warning--text font-weight-bold mr-2'>{{suNotes[0].note_year + " SU field note:"}}</span>
        <span>{{ suNotes[0].note }}</span>
      </v-card-text>
      <v-card-text v-if='wo.wo_type_obj.category === "BD"' class='pt-0'>
        <span class='font-weight-bold mr-2'>BD Specific Instructions:</span>
        <span>{{ wo.project_obj.project_detail.bd_instr_perm_field }}</span>
      </v-card-text>
      <v-card-text v-if='bdNotes.length' class='pt-0'>
        <span class='warning--text font-weight-bold mr-2'>{{bdNotes[0].note_year + " BD field note:"}}</span>
        <span>{{ bdNotes[0].note }}</span>
      </v-card-text>
    </wc-data-box>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import irrigationAPI from '@/modules/irrigation/api/irrigations'

export default {
  name: 'field-instructions',
  props: {
    wo: {
      required: true
    }
  },
  mounted() {
    this.getOneTimeNotes()
  },
  data: () => ({
    suNotes: [],
    bdNotes: [],
    notes: [],
    helpText: `The field instructions are pulled from the connected project.
      They are the "standing" instructions for this project.<br><br>To make changes
      to these instructions, you will need to change the field instructions on the
      project itself.<br><br>Permanent SU and BD notes will only appear on work orders of that type.
      `
  }),
  methods: {
    async getOneTimeNotes () {
      let year = parseInt(moment(this.wo.date_created).format('YYYY'))
      if (this.wo.project && this.wo.project_obj.division_obj.division === 'Irrigation') {
        this.notes = await irrigationAPI.getOneTimeNotes(this.wo.project_obj.id)
        this.suNotes = _.filter(this.notes, { 'note_year': year, 'is_su_note': true, 'note_type': 'F' })
        this.bdNotes = _.filter(this.notes, { 'note_year': year, 'is_su_note': false, 'note_type': 'F' })
      }
    }
  }
}
</script>
